// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto';
import '@babel/polyfill';
import jQuery from 'jquery';
import Vue from 'vue';
import App from './App';
import store from './store';

global.jquery = jQuery;
global.$ = jQuery;
window.$ = require('jquery');

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  components: { App },
  template: '<App/>',

});



// WEBPACK FOOTER //
// ./src/main.js